/* Source: /home/sidsolaiyappan/skooch_ai/shared/auth_helpers.jac */
import {__jacJsx, __jacSpawn} from "@jac/runtime";
function computeRememberedEmail(email, remember) {
  if (!remember) {
    return "";
  }
  return (email ? email : "");
}
export {computeRememberedEmail};
//# sourceMappingURL=auth_helpers.js.map
